module.exports = __webpack_public_path__ + "static/logistics-planning-2f67c105a3bc3aef0c0caf6c71142688.png";